import { AnyAction } from 'redux';
import { DRAFT_CHANGE_STATUSES } from '../../shared/constants/commonConstants';
import actionTypes from '../types/savedDraftTypes';

const initialState = {
  savedDraftList: [],
  draftCurrentStatus: DRAFT_CHANGE_STATUSES.NO_CHANGE,
  selectedDraftId: 0,
  draftErrorMessage: '',
  isLoading: false,
  responseStatus: '',
  draftDeleteCounter: 0,
};

const reducer = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.SAVED_DRAFT:
      return {
        ...state,
        savedDraftList: action.payload,
      };
    case actionTypes.UPDATE_SAVE_DRAFT_STATUS:
      return {
        ...state,
        draftCurrentStatus: action.payload,
      };
    case actionTypes.UPDATE_DRAFT_ID:
      return {
        ...state,
        selectedDraftId: action.payload,
      };
    case actionTypes.SET_DRAFT_ERROR:
      return {
        ...state,
        isLoading: false,
        draftErrorMessage: action.payload,
      };
      case actionTypes.SEARCH_DRAFT_LIST:
        return {
          ...state,
          isSearchClicked: state.isSearchClicked + 1,
        };
      case actionTypes.DRAFT_LOADING:
        return {
          ...state,
          isLoading: action.payload,
        };
      case actionTypes.DRAFT_RESPONSE_STATUS:
        return {
          ...state,
          responseStatus: action.payload,
        };
      case actionTypes.DRAFT_DELETE_COUNTER: {
        return {
          ...state,
          draftDeleteCounter: state.draftDeleteCounter + 1,
        };
      }

    default: return state;
  }
};

export { reducer as savedDraftReducer };
